import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import ButtonFieldLayout from '../../layouts/common/ButtonFieldLayout';
import { useSubmitField } from '../../hooks/useSubmitField';

interface Props {
  className?: string;
}

const DisableCommentsField: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('disableComments', {
    initAdapter: ({ deviation }) => !deviation?.isCommentable,
    submitAdapter: ({ disableComments }) => ({
      allow_comments: !disableComments,
    }),
  });

  return (
    <ButtonFieldLayout
      label={t('deviationSubmit.form.disableComments.label')}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
    >
      <MainToggle
        variant="main"
        id={id}
        size={isMobile ? 'large' : 'small'}
        value={value}
        onChange={onChange}
        aria-labelledby={`${id}-label`}
      />
    </ButtonFieldLayout>
  );
};
DisableCommentsField.displayName = 'DisableCommentsField';

export default DisableCommentsField;
